// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__1QY8j","item":"PaymentsMobile_item__7IUvo","label":"PaymentsMobile_label__2e9YG","amount":"PaymentsMobile_amount__1oqsm"};